export default __webpack_public_path__ + "static/banner_back-1e80745185a5f1e05c1e1d77492ff6f3.webp";